// extracted by mini-css-extract-plugin
export var hideEditor = "_n4-2";
export var infoIcon = "_n4-3";
export var label = "_n4-1";
export var labelContainer = "_n4-0";
export var readonlyText = "_n4-4";